export default __webpack_public_path__ + "static/media/image-work-team-w@3x.400be92b.png";